import { useCRMDataClient } from "@/services/data-client/DataClientContext";
import { jsonParser } from "@/services/generic.methods";
import { getLoggedinUser } from "@/store/slices/auth/authSlice";
import { useState } from "react";
import { useSelector } from "react-redux";

const parseSettingValue = (value) => {
  if (typeof value !== "string") return value;
  try {
    return jsonParser(value);
  } catch {
    return value;
  }
};

const normalizeUserSetting = (response, key = "") => {
  if (!response) return null;

  let setting = response;

  if (response?.userSetting) {
    setting = response.userSetting;
  } else if (Array.isArray(response)) {
    setting = key
      ? (response.find((item) => (item?.key || item?.Key) === key) ??
        response[0])
      : response[0];
  } else if (Array.isArray(response?.items)) {
    setting = key
      ? (response.items.find((item) => (item?.key || item?.Key) === key) ??
        response.items[0])
      : response.items[0];
  }

  const settingId = setting?.id || setting?.Id;
  const settingKey = setting?.key || setting?.Key;
  const rawValue = setting?.value ?? setting?.Value;

  if (!settingId && key && settingKey !== key) return null;

  return {
    ...setting,
    id: settingId,
    key: settingKey || key,
    value: parseSettingValue(rawValue),
  };
};

export const isUserSettingEnabled = (value) =>
  value === true ||
  value === "true" ||
  value === "True" ||
  value?.dismissed === true;

const useUserSettings = () => {
  const [settings, setSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [requestPending, setRequestPending] = useState(false);
  const { client: dataClient } = useCRMDataClient();
  const user = useSelector(getLoggedinUser);

  const getUserId = () =>
    user?.UserGUID || user?.userGUID || user?.userId || user?.UserID || null;

  const getUserSettings = (key = "") => {
    const userId = getUserId();
    console.log(userId, "userId", "guid-------------", user);

    if (!userId) return Promise.resolve(null);

    setSettingsLoading(true);
    setFetched(false);

    const request = key
      ? dataClient.userSettings.getUserSettingByKey(userId, key)
      : dataClient.userSettings.getUserSettings(userId);

    return request
      .then((response) => {
        const normalized = normalizeUserSetting(response, key);
        setSettings(normalized);
        return normalized;
      })
      .catch((err) => {
        console.log("onError fetching user settings:", err);
        setSettings(null);
        return null;
      })
      .finally(() => {
        setSettingsLoading(false);
        setFetched(true);
      });
  };

  const addUserSettings = (key, value) => {
    const userId = getUserId();
    if (!userId) return Promise.resolve(null);

    // setSettings((prev) => ({
    //   ...(prev || {}),
    //   key,
    //   value,
    //   userId,
    //   clientType: 1,
    // }));

    setRequestPending(true);

    return dataClient.userSettings
      .saveUserSettings(userId, key, value)
      .then((response) => {
        const normalized = normalizeUserSetting(response, key);
        if (normalized) {
          setSettings(normalized);
        }
        return response;
      })
      .catch((err) => {
        console.log("onError saving user settings:", err);
        return null;
      })
      .finally(() => setRequestPending(false));
  };

  const deleteUserSettings = (key) => {
    const userId = getUserId();
    if (!userId || !key) return Promise.resolve(null);

    setRequestPending(true);

    return dataClient.userSettings
      .deleteUserSettings(userId, key)
      .then((response) => {
        setSettings((prev) => (prev?.key === key ? null : prev));
        return response;
      })
      .catch((err) => {
        console.log("onError deleting user settings:", err);
        return null;
      })
      .finally(() => setRequestPending(false));
  };

  return {
    settings,
    settingsLoading,
    fetched,
    getUserSettings,
    addUserSettings,
    deleteUserSettings,
    requestPending,
    setSettings,
  };
};

export default useUserSettings;

export const SettingsKey = {
  new_feature: "new_feature",
  quick_stats: "quick_stats",
  dashboard_default: "dashboard_default",
  main_dashboard: "dashboard_main",
  user_theme: "usertheme",
  appointment_tour: "appointment_tour",
  crm_tour: "crm_tour",
  appointment_welcome: "appt_guide_tour",
};
